import { AsyncPipe } from "@angular/common";
import { RouterOutlet } from "@angular/router";
import { Component, inject } from "@angular/core";

import { NavbarComponent } from "../navbar/navbar.component";
import { SidebarComponent } from "../sidebar/sidebar.component";
import { AuthService, SidebarToggleService } from "../../services";

@Component({
  selector: "app-layout",
  standalone: true,
  imports: [RouterOutlet, NavbarComponent, SidebarComponent, AsyncPipe],
  templateUrl: "./layout.component.html",
  styleUrl: "./layout.component.scss",
})
export class LayoutComponent {
  isSidebarOpened$ = inject(SidebarToggleService).isSidebarOpened$;

  readonly isGuest = inject(AuthService).isGuest;
}
